import dayjs from 'dayjs';
export const dayjsUsage = (
  date: 'now' | 'day' | 'yesterday' | 'week' | 'halfMonth' | 'month' | 'year',
  format = 'YYYY-MM-DD HH:mm:ss',
) => {
  let startTime = '';
  let endTime = '';
  let now = '';
  switch (date) {
    case 'now':
      now = dayjs().format(format);
      break;
    // 今日 00:00:00  23:59:59
    case 'day':
      startTime = dayjs(dayjs()).startOf('day').format(format);
      endTime = dayjs(dayjs()).endOf('day').format(format);
      break;
    // 昨天
    case 'yesterday':
      startTime = dayjs().subtract(1, 'day').format(format);
      endTime = dayjs().subtract(1, 'day').format(format);
      break;
    // 现在往前推七天的数据
    case 'week':
      startTime = dayjs().subtract(7, 'day').format(format);
      endTime = dayjs().format(format);
      break;
    case 'halfMonth':
      startTime = dayjs().subtract(15, 'day').format(format);
      endTime = dayjs().format(format);
      break;
    case 'month':
      startTime = dayjs().subtract(1, 'month').format(format);
      endTime = dayjs().format(format);
      break;
    case 'year':
      startTime = dayjs().subtract(1, 'year').format(format);
      endTime = dayjs().format(format);
      break;
    default:
      break;
  }
  return {
    startTime,
    endTime,
    now,
  };
};

/**
 * 获取时间差
 * @param startTime
 * @param endTime
 * @returns
 */
function getTimeDiff(startTime: string | Date, endTime: string | Date) {
  const t = dayjs(endTime).toDate().getTime() - dayjs(startTime).toDate().getTime();
  return t;
}

/**
 * @desc ${startTime - endTime}的剩余时间,startTime大于endTime时，均返回0
 * @param { Date | String } startTime
 * @param { Date | String } endTime
 * @returns { Object } { d, h, m, s } 天 时 分 秒
 */
export function timeLeft(
  startTime: string | Date,
  endTime: string | Date,
): {
  d: number;
  h: number;
  m: number;
  s: number;
} {
  if (!startTime || !endTime) {
    return {
      d: 0,
      h: 0,
      m: 0,
      s: 0,
    };
  }
  const t = getTimeDiff(startTime, endTime);
  let d = 0;
  let h = 0;
  let m = 0;
  let s = 0;
  if (t >= 0) {
    d = Math.floor(t / 1000 / 3600 / 24);
    h = Math.floor((t / 1000 / 60 / 60) % 24);
    m = Math.floor((t / 1000 / 60) % 60);
    s = Math.floor((t / 1000) % 60);
  }
  return {
    d,
    h,
    m,
    s,
  };
}

/**
 * @desc ${startTime - endTime}的剩余时间,startTime大于endTime时， 返回true 否则false
 */
export function overCurrentTime(startTime: string | Date, endTime: string | Date): boolean {
  if (!startTime || !endTime) {
    return false;
  }
  const t = getTimeDiff(startTime, endTime);
  if (t >= 0) {
    return false;
  }
  return true;
}
